var React = require('react');

function CheckboxDefault (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"2","y":"2","width":"20","height":"20","rx":"4","fill":"transparent","strokeWidth":"1","stroke":"rgba(92, 109, 150, 0.5)"}));
}

CheckboxDefault.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CheckboxDefault;

CheckboxDefault.default = CheckboxDefault;
